$(document).ready(function()
{
	/*
	//
	//
	// SET UP QUEUE FOR AJAX CALLS
	//
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	var Queue = function ()
	{
		var previous = new $.Deferred().resolve();

		return function (fn, fail)
		{
			return previous = previous.then(fn, fail || fn);
		};
	};

	var queue = Queue();


  /*
	//
	//
	// ADD TO CART BUTTON
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('#btn-add-to-cart').click(function(e)
	{
		e.preventDefault();
    	console.log('add to cart');

		/*
		//
		//
		// SET UP PRODUCT DETAILS
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		var $btn = $(this);
		var product_id = $('input[name=id]').val();
		var quantity = parseInt($('#quantity').val());

		var properties = {};

    var $form = $(this).parents('form');
		$form.find('[name^="properties"]').each(function(i,v)
    {
			var start = $(this).attr('name').indexOf('[') + 1;
			var end = $(this).attr('name').indexOf(']');
			var n = $(this).attr('name').substring(start, end);
			var v = $(this).val();

			properties[n] = v;

    }).get();



		/*
		//
		//
		// IF FREE ITEM BUNDLE IS AVAILABLE, ADD BOTH ITEMS TO CART
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
  	if ($('.bundle-block-free-item').length > 0)
    {
	    var free_item_variant_id = $('.bundle-block-free-item').attr('data-variant-id');
			var free_item_quantity = $('input#quantity').val();

	    if (free_item_variant_id)
	    {
		    var random_key = new Date().getTime();

	 	 		//
				//
				// ADD MAIN PRODUCT TO CART
				//
				//
				properties.bundle_free_item = 'true';
				properties.bundle_key = random_key;

				queue(function()
				{
					return addToCart($btn, product_id, quantity, properties);
				});

				//
				//
				// ADD FREE ITEM TO CART
				//
				//
				var free_item_properties =
				{
					bundle_free_item: 'true',
					bundle_key: random_key,
					bundle_is_free_item: 'true'
				};

				queue(function()
				{
			    return $.post('/cart/add.js',
					{
						quantity: free_item_quantity,
						id: free_item_variant_id,
						properties: free_item_properties

					}, function()
					{
					}, 'json').done(function(variant)
					{
						updateCartTotals();

					}).fail(function(msg)
					{
					});
				});


				return false;
	    }
    }



		/*
		//
		//
		// REGULAR OL' JUST ADD THIS PRODUCT TO CART
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
    addToCart($btn, product_id, quantity, properties);

  });





  /*
	//
	//
	// ADD TO CART
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
  function addToCart($btn, product_id, quantity, properties)
  {
		//
		// HIDE BTN AND QTY / SHOW SPINNER
		//
		$btn.hide();
		$('#QtyArea').hide();
	  $('<div class="spinner-add-to-cart sk-spinner sk-spinner-pulse"></div>').insertAfter($btn);

    //
    // ADD TO CART
    //
    return $.post('/cart/add.js',
		{
			quantity: quantity,
			id: product_id,
			properties: properties

		}, function()
		{
			//console.log('added');

		}, 'json').done(function(variant)
		{
			$('.checkout-callout-single-product').remove();
			$('.added-success-message').remove();

			//
			// REMOVE SPINNER
			//
			$('.spinner-add-to-cart').remove();

			//
			// SHOW SUCCESS MESSAGE
			//
			if ($('.added-success-message').length < 1)
			{
				var $added_success = $("<p class='added-success-message'>Item successfully added to bag.</p>");
				$added_success.insertAfter($btn);
			}

			//
			// SHOW CHECKOUT CALLOUT
			//
			if ($('.checkout-callout-single-product').length < 1)
			{
				var $checkout_callout = $("<div class='checkout-callout checkout-callout-single-product'></div>");
				$checkout_callout.append("<a class='btn' href='/cart'>Go To Bag</a>");
				$checkout_callout.hide().insertAfter('#product-form-bar');
			}

			//
			// UPDATE CART TOTALS
			//
			updateCartTotals(function()
			{
				$checkout_callout.show();
			});

			//
			// RELOAD/UPDATE SPEND REMINDER BAR
			//
			if ($('#spend-reminder').length > 0 )
			{
				if ($('#spend-reminder span').length < 1) {
					$("#spend-reminder").slideUp("fast", function() {
						$("#spend-reminder").load(location.href+" #spend-reminder>*", "", function() {
							$("#spend-reminder").slideDown();
						});
					});
				} else {
					$("#spend-reminder").load(location.href+" #spend-reminder>*", "");
				}
			}

			//
			// CLEAR SUCCESS MESSAGE / SHOW BUTTON AND QTY AGAIN
			//
			setTimeout(function()
			{
				$added_success.fadeOut(400, function()
				{
					$btn.fadeIn();
					$('#QtyArea').fadeIn();
                  	$(this).closest('form').find("input[type=text], textarea").val("");
	                $(this).remove();
				});

			}, 3000);


		}).fail(function(msg)
		{
			//console.log('fail');
			//console.log(msg);

      alert('The quantity that you entered is not available. Please select a lower quantity to continue');
      $('.spinner-add-to-cart').remove();
      $btn.show();
      $('#QtyArea').show();

		});
  }



	/*
	//
	//
	// ADD BUNDLE TO CART BUTTON
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.bundle-variant-option').click(function(e)
	{
		e.preventDefault();

		var $bundle_product = $(this).parents('.bundle-product');

		//
		// TOGGLE SELECTED VARIANT
		//
		$(this).siblings('.bundle-variant-option').removeClass('selected');
		$(this).addClass('selected');

		//
		// UPDATE VARIANT TITLE
		//
		$bundle_product.find('.bundle-variant-title').text($(this).find('span').text());

		//
		// TOGGLE VARIANT IMAGE
		//
		var variant_handle = $(this).attr('data-variant-handle');

		$bundle_product.find('.bundle-product-image-thumb').hide();

		var $variant_img = $bundle_product.find('.bundle-product-image-thumb-'+variant_handle).first();
		if ($variant_img.length > 0)
		{
			$variant_img.show();
		}
		else
		{
			$bundle_product.find('.bundle-product-image-thumb').first().show();
		}

		//
		// UPDATE VARIANT PRICE
		//
		var variant_price = $(this).attr('data-variant-price');
		var variant_discounted_price = $(this).attr('data-variant-discounted-price');

		$bundle_product.find('.bundle-pricing s').text(variant_price);
		$bundle_product.find('.bundle-pricing span').text(variant_discounted_price);


		return false;
	});

	/*
	//
	//
	// ADD BUNDLE TO CART BUTTON
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
  $('.btn-add-bundle-to-cart').click(function(e)
  {
	  e.preventDefault();

		var $bundle = $(this).parents('.bundle-block');

		//
		// GET ALL VARIANT IDS FOR PRODUCTS IN BUNDLE
		//
		var the_variant_ids = [];

		$bundle.find('.bundle-product').each(function(i,element)
		{
			//
			// IF PRODUCT HAS VARIANT OPTIONS, ADD SELECTED VARIANT
			//
			if ($(this).find('.bundle-variant-option.selected').length > 0)
			{
				var variant_id = $(this).find('.bundle-variant-option.selected').attr('data-variant-id');
				the_variant_ids.push(variant_id);
			}
			//
			// ELSE JUST ADD PRODUCT
			//
			else
			{
				var product_id = $(this).find('.bundle-product-option').attr('data-variant-id');
				the_variant_ids.push(product_id);
			}
		});

		//
		// ADD ALL TO CART
		//
		addBundleToCart($bundle, the_variant_ids);

		return false;
	});

	/*
	//
	//
	// ADD BUNDLE TO CART
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	function addBundleToCart($bundle, the_variant_ids)
	{
		var $bundle_actions = $bundle.find('.bundle-actions');
		var $btn = $bundle.find('.btn-add-bundle-to-cart');
		$btn.hide();
	  $('<div class="spinner-add-bundle-to-cart sk-spinner sk-spinner-pulse"></div>').insertAfter($btn);

	  //console.log(the_variant_ids);
		//return false;

		var bundle_name = $bundle.attr('data-bundle-name');
		var bundle_product_id = $bundle.attr('data-bundle-product-id');
	  var random_key = new Date().getTime();

	  //console.log(bundle_name);
	  //console.log(bundle_product_id);
	  //console.log(random_key);

	  $.each(the_variant_ids, function(i, variant_id)
	  {
	  	var product_id = variant_id;
		  var properties =
		  {
			  bundle_name: bundle_name,
			  bundle_product_id: bundle_product_id,
			  bundle_key: random_key
			};

		  queue(function()
			{
				return $.post('/cart/add.js',
				{
					quantity: 1,
					id: product_id,
					properties: properties

				}, function()
				{
					//console.log('added');

				}, 'json').done(function(variant)
				{
					//console.log('ADDED VARIANT:');
					//console.log(variant);

				}).fail(function(msg)
				{
					//console.log(msg);

				});
			});

		});

		queue(function()
		{
			$('.checkout-callout-bundle').remove();
			$('.bundle-added-success-message').remove();

			//
			// REMOVE SPINNER
			//
			$bundle.find('.sk-spinner').remove();
			//$btn.show();

			//
			// SHOW SUCCESS MESSAGE
			//
			if ($('.bundle-added-success-message').length < 1)
			{
				var $added_success = $("<p class='bundle-added-success-message'>Bundle successfully added to bag.</p>");
				$added_success.appendTo($bundle_actions);
			}

			//
			// SHOW CHECKOUT CALLOUT
			//
			if ($('.checkout-callout-bundle').length < 1)
			{
				var $checkout_callout = $("<div class='checkout-callout checkout-callout-bundle'></div>");
				$checkout_callout.append("<a class='btn' href='/cart'>Go To Bag</a>");
				$checkout_callout.appendTo($bundle_actions);
			}

			//
			// UPDATE CART TOTALS
			//
			updateCartTotals();

			//
			// CLEAR SUCCESS MESSAGE / SHOW BUTTON AND QTY AGAIN
			//
			setTimeout(function()
			{
				$added_success.fadeOut(400, function()
				{
					$btn.fadeIn();
					$(this).remove();
				});

			}, 3000);

			return true;
		});

  }


	/*
	//
	//
	// UPDATE CART TOTAL IN HEADER AND MODAL
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	function updateCartTotals(callback)
	{
		$.get('/cart.js', function() {}, 'json').done(function(cart)
		{
			$('.cart-items-count').text(cart.item_count);

			if (callback)
			{
				callback();
			}

		});
	}


	/*
	//
	//
	// STICKY HEADER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$(window).on('scroll', function()
	{
		var scrolltop = $(window).scrollTop();

		if (scrolltop > 107)
		{
			$('body').addClass('sticky-header');

			setTimeout(function()
			{
				$('header').css('top', '0px');
			}, 1000);

		}
		else
		{
			$('header').removeAttr('style');
			$('body').removeClass('sticky-header');
		}

	});

	/*
	//
	//
	// MENU TOGGLE
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('#menu-toggle').click(function(e)
	{
		e.preventDefault();

		if ($('#menu-mobile').hasClass('open'))
		{
			$('#menu-mobile').removeClass('open');
			$('body').removeClass('mobile-menu-open');
		}
		else
		{
			$('#menu-mobile').addClass('open');
			$('body').addClass('mobile-menu-open');
		}

		return false;
	});

	/*
	//
	//
	// BANNER SLIDER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.banner-slider').owlCarousel(
	{
		singleItem: true,
		autoPlay: 4000
	});

	/*
	//
	//
	// HOME COLLECTION SLIDER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.home-collection-images').each(function(i,v)
	{
		var owl = $(this);

		owl.owlCarousel(
		{
			singleItem:true,
			navigation:false,
			pagination:false,
			slideSpeed:1000
		});

		owl.on(
		{
			mouseenter: function()
			{
				setTimeout(function()
				{
					owl.trigger('owl.next');
					owl.trigger('owl.play',1500);

				}, 100);
			},
			mouseleave: function()
			{
				owl.trigger('owl.stop');
			}
		});

		$(this).find('img').on('click', function(e)
		{
			if ($(this).attr('data-link'))
			{
				window.location.href = $(this).attr('data-link');
			}
		});

	});

	/*
	//
	//
	// BEST SELLERS SLIDER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.home-slider').owlCarousel(
	{
		items: 4,
		navigation: true,
		navigationText: ["<svg width='26' viewBox='0 0 27.167 48.167' style='stroke:#000000;'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>", "<svg width='26' viewBox='0 0 27.167 48.167' style='stroke:#000000;'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"],
		pagination:true,
		itemsCustom: [[0, 1], [450, 2], [768, 3], [1125, 4]]
	});


	/*
	//
	//
	// NEWSLETTER SIGNUP (CUSTOMER FORM)
	//
	//
	///////////////////////////////////////////////////////////////////////////// */

	//
	//
	// IN FOOTER, EMAIL FORM TRIGGERS MODAL TO ASK FOR ADDITIONAL INFO
	//
	//
	$('#btn-trigger-newsletter-modal').click(function(e)
	{
		e.preventDefault();

		var email = $(this).parents('.input-group-newsletter').find('input[type=email]').val();


		$('#newsletter-modal-header').css({'height':'80px'});
		$('#newsletter-modal-header h1').hide();
		$('#newsletter-modal-header p').hide();
		$('#newsletter-modal input[type=email]').val(email);
		$('#newsletter-modal .btn-submit-newsletter-email').trigger('click');

		var inst = $('#newsletter-modal').remodal();
		inst.open();
	});

	//
	//
	// MODAL NEWSLETTER FORM HAS TWO PARTS
	//
	//
	$('.btn-submit-newsletter-email').click(function(e)
	{
		e.preventDefault();

		var $input_group = $(this).parents('.input-group-newsletter');
		$input_group.find('.btn-submit-newsletter-email').hide();
		$input_group.next('.input-group-newsletter-part-2').show();
	});

	$('.input-group-newsletter-part-2 input[type=text]').on('keyup', function(e)
	{
		$(this).parents('.input-group-newsletter-part-2').find('.btn').text('Join the Newsletter');
	});


	$('.newsletter-signup-form').on('submit', function(e)
	{
		e.preventDefault();

		var $form = $(this);
		var method = $(this).attr('method');
		var action = $(this).attr('action');
		var data = $(this).serialize();

		$.ajax(
		{
			type: method,
			url: action,
			data: data

		}).done(function(response)
		{
			//console.log(response);
			$("<p class='form-success'>Thanks! You're now subscribed!</p>").insertBefore($form)
			$form.hide();

		}).fail(function(msg)
		{
			//console.log(msg);
			$("<p class='form-error'>Please enter a valid email address.</p>").insertBefore($form)
		});

		return false;
	});



	//var inst = $('#newsletter-modal').remodal();
	//inst.open();




	/*
	//
	//
	// HANDLE NEWSLETTER MODAL
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	/*
	Cookies.set('name', 'value');
	Cookies.get('name');
	Cookies.get(); // => { name: 'value' }
	Cookies.remove('name');
	Cookies.set('name', { foo: 'bar' });
	Cookies.getJSON('name'); // => { foo: 'bar' }
	*/

	//Cookies.remove('newsletter-modal-shown');
	//Cookies.remove('pageviews-for-newsletter-modal');

	handleNewsletterModal();

	function handleNewsletterModal()
	{
		var newsletter_modal_delay = 1500;
		var show_signup_on_page = 3 - 1;

		var newsletter_modal_shown = Cookies.get('newsletter-modal-shown');

		if (newsletter_modal_shown)
		{
			return;
		}

		var pageviews = parseInt(Cookies.get('pageviews-for-newsletter-modal'));

		if (!pageviews) pageviews = 0;

		if (pageviews >= show_signup_on_page)
		{
			setTimeout(function()
			{
				var inst = $('#newsletter-modal').remodal();
				inst.open();

				Cookies.set('newsletter-modal-shown', true);

			}, 2000);
		}

		pageviews++;
		Cookies.set('pageviews-for-newsletter-modal', pageviews);
	}


	/*
	//
	//
	// COLLECTION SORT
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('#collection-sort').on('change', function()
	{
		window.location.href = $(this).val();
	});


	/*
	//
	//
	// PRODUCT BLOCK CLICK
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.product-block').click(function(e)
	{
		if ($(e.target).is('a, button'))
		{
			return true;
		}

		e.preventDefault();
		window.location.href = $(this).attr('href');
		return false;
	});

	/*
	//
	//
	// QUANTITY INPUTS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$(document).on('click', '.quantity-decrement',(function(e)
	{
		var val = parseInt($(this).parent().find('input[type=number]').val());
		if (val > 1)
		{
			$(this).parent().find('input[type=number]').val(val - 1)
		}
	}));

	$(document).on('click', '.quantity-increment',(function(e)
	{
		var val = parseInt($(this).parent().find('input[type=number]').val());
		$(this).parent().find('input[type=number]').val(val + 1)
	}));



	/*
	//
	//
	// PRODUCT PAGE
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	if (typeof(PRODUCT_JSON) != 'undefined')
  {
		/*
		//
		//
		// PRODUCT IMAGE THUMB
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		$('.product-image-thumb').click(function(e)
		{
			e.preventDefault();

			//
			//
			// YOUTUBE VIDEO EMBED
			//
			//
			if ($(this).hasClass('product-image-thumb-video'))
			{
				$('#product-image-main .product-video-wrapper').remove();

				var video_url = $(this).attr('data-video-url');
				var url_vars = getURLVars(video_url);

				if (url_vars.v)
				{
					var video_src = '//youtube.com/embed/' + url_vars.v;

					$('#product-image-main img').hide();
					$('#product-image-main').append("<div class='product-video-wrapper'><iframe width='560' height='349' src='" + video_src + "' frameborder='0' allowfullscreen></iframe></div>");
				}
			}
			//
			//
			// REGULAR IMAGE
			//
			//
			else
			{
				var src = $(this).find('.product-image-thumb-large').attr('src');

				if (src)
				{
					$('#product-image-main .product-video-wrapper').remove();
					$('#product-image-main img').attr('src', src);
					$('#product-image-main img').show();
				}
			}

			return false;
		});

		function getURLVars(url)
		{
		  var vars = [], hash;
		  var hashes = url.slice(url.indexOf('?') + 1).split('&');
		  for(var i = 0; i < hashes.length; i++)
		  {
		      hash = hashes[i].split('=');
		      vars.push(hash[0]);
		      vars[hash[0]] = hash[1];
		  }
		  return vars;
		}

		/*
		//
		//
		// VARIANT OPTIONS
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		$('.variant-option').click(function(e)
		{
			e.preventDefault();

			$('.variant-option').removeClass('variant-option-selected');
			$(this).addClass('variant-option-selected');

			var price = $(this).attr('data-price');
			var oldPrice = $(this).attr('data-old-price');

			if (oldPrice != undefined) {
              var priceNum = Number(price.replace(/[^0-9\.-]+/g,""));
              var oldPriceNum = Number(oldPrice.replace(/[^0-9\.-]+/g,""));

              if (priceNum < oldPriceNum) {
                $('span#product-price').replaceWith("<span id='product-price' class='sale-price' itemprop='price' content='"+ priceNum +"'> "+ price +"</span>");
                if ($('span#old-price').length){
                  $('span#old-price').text(oldPrice);
                } else {
                  $('span#product-price').before("<span id='old-price' class='old-price'>"+ oldPrice +"</span>");
                }
              } else {
                if ($('span#old-price').length > 0){
                  $('span#old-price').remove();
                }
                $('span#product-price').replaceWith("<span id='product-price' class='sale-price' itemprop='price' content='"+ priceNum +"'>"+ price +"</span>");
              }
			} else {
				$('span#product-price').text(price);
			}

			var variant_handle = $(this).attr('data-variant-handle');

			$('.product-image-thumb').not('.product-image-thumb-all').not('.product-image-thumb-video').hide();
			$('.product-image-thumb-'+variant_handle).show();
			$('.product-image-thumb-'+variant_handle).first().click();

			var variant_name = $(this).attr('data-variant-name');
			$('#variant-name').text(variant_name);

			var variant_id = $(this).attr('data-variant-id');

			var $form = $(this).parents('form');
			$form.find('input[name=id]').val(variant_id);

            var inventory_mgmt = $(this).attr('data-inventory-mgmt');
			var inventory_qty = $(this).attr('data-inventory-qty');

          	if (inventory_mgmt)
            {
              if (!inventory_qty) inventory_qty = 1;

              if (inventory_qty > 0)
              {
                  $form.find('button.btn-add-to-cart').removeClass('btn-disabled');
                  $form.find('button.btn-add-to-cart').removeAttr('disabled');
                  $form.find('button.btn-add-to-cart').text('Add to Bag');

              }
              else
              {
               	  $form.find('button.btn-add-to-cart').addClass('btn-disabled');
                  $form.find('button.btn-add-to-cart').attr('disabled','disabled');
                  $form.find('button.btn-add-to-cart').text('Sold Out');
              }
            }

			var uri = updateUrlParameter(window.location.href, 'variant', variant_id);

			window.history.pushState('variantHistory', variant_name, uri);

			return false;
		});


		function updateUrlParameter(uri, key, value)
		{
	    var i = uri.indexOf('#');
	    var hash = i === -1 ? ''  : uri.substr(i);
					uri = i === -1 ? uri : uri.substr(0, i);

	    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	    if (uri.match(re))
	    {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
	    }
	    else
	    {
        uri = uri + separator + key + "=" + value;
	    }
	    return uri + hash;
		}


		var product_ingredients_max_height = $('#product-ingredients-wrap').css('max-height');
		$('#product-ingredients-wrap').hide().css({ 'max-height':'none' });
		var product_ingredients_height = $('#product-ingredients-wrap').outerHeight(true);
		$('#product-ingredients-wrap').css({ 'max-height': product_ingredients_max_height }).show();

		//console.log(product_ingredients_max_height);
		//console.log(product_ingredients_height);

		if (parseInt(product_ingredients_height) <= parseInt(product_ingredients_max_height))
		{
			$('#product-ingredients-read-more').hide();
		}

		$('#product-ingredients-read-more').click(function(e)
		{
			e.preventDefault();
			$('#product-ingredients-wrap').css({'max-height':'2000px'});
			$(this).hide();
			return false;
		});




		/*
		//
		//
		// SOCIAL SHARE BUTTONS
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		$('#product-share-icons a').click(function(e)
		{
			e.preventDefault();
			openSharePopup($(this).attr('href'));
			return false;
		});

		function openSharePopup(url)
		{
			var width = 560;
			var height = 440;
			var left = Number((screen.width/2)-(width/2));
			var top = Number((screen.height/2)-(height/2));

			var new_window = window.open(url, '_blank', 'height='+height+',width='+width+',top='+top+',left='+left+',scrollbars=yes,resizable=yes');
			if (window.focus) { new_window.focus(); }
			return false;
		}



	}





	/*
	//
	//
	// CUSTOMER ACCOUNTS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	if ($('.customer-birthday').length > 0)
	{
		$('.customer-birthday').each(function()
		{
			var cleave = new Cleave(this,
			{
		    date: true,
		    datePattern: ['m', 'd', 'Y']
			});
		});

		$('.customer-birthday').on('keyup', function(e)
		{
			var $input = $(this);
			var $tags_input = $(this).siblings('.customer-birthday-tags');

			$('.birthday-error').remove();

			var bday = $(this).val();

			if (!validateDate(bday))
			{
				var tags = $tags_input.attr('data-additional-tags');
				$tags_input.val(tags);
			}
			else
			{
				var tags = $tags_input.attr('data-additional-tags');
				if (tags != '') tags = tags + ',';
				$tags_input.val(tags + 'birthday,birthday: ' + bday);
			}

		});

		$('.customer-birthday').on('blur', function(e)
		{
			var $input = $(this);
			var bday = $(this).val();

			if (bday == '')
			{
				return;
			}

			if (!validateDate(bday))
			{
				$('<p class="input-error-message birthday-error">Please enter a valid birthdate in the format MM/DD/YYYY</p>').insertAfter($input);
				$tags_input.val('');
			}
			else
			{
				$('.birthday-error').remove();
			}
		});
	}

	function validateDate(testdate)
	{
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/ ;
    return date_regex.test(testdate);
	}

	$('#btn-forgot-password').click(function(e)
	{
		e.preventDefault();

		$('#form-container-login').hide();
		$('#form-container-reset-password').show();

		return false;
	});

	$('#btn-cancel-reset-password').click(function(e)
	{
		e.preventDefault();

		$('#form-container-reset-password').hide();
		$('#form-container-login').show();

		return false;
	});

	if (window.location.hash == '#recover')
	{
		$('#form-container-login').hide();
		$('#form-container-reset-password').show();
	}

	/*
	//
	//
	// ADDRESSES
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	if ($('.form-add-address').length > 0)
	{
	  new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new',
	  {
	    hideElement: 'address_province_container_new'
	  });

		$('.form-edit-address').each(function(i,element)
		{
			var address_id = $(this).attr('data-address-id');

			new Shopify.CountryProvinceSelector('address_country_' + address_id, 'address_province_' + address_id,
	    {
	      hideElement: 'address_province_container_' + address_id
	    });
		});
	}

  $('.btn-add-new-address').click(function(e)
	{
		e.preventDefault();
		$('.form-add-address').toggle();
		return false;
	});
	$('.btn-cancel-add-address').click(function(e)
	{
		e.preventDefault();
		$('.form-add-address').hide();
		return false;
	});

	$('.btn-edit-address').click(function(e)
	{
		e.preventDefault();
		$(this).parents('.address-block').toggleClass('address-block-edit');
		$('#edit_address_' + $(this).attr('data-address-id')).toggle();
		return false;
	});
	$('.btn-delete-address').click(function(e)
	{
		e.preventDefault();
		if (confirm('Are you sure you want to delete this address?'))
		{
			Shopify.postLink('/account/addresses/' + $(this).attr('data-address-id'), { 'parameters': { '_method': 'delete' }});
		}
		return false;
	});
	$('.btn-cancel-edit-address').click(function(e)
	{
		e.preventDefault();
		$(this).parents('.address-block').toggleClass('address-block-edit');
		$('#edit_address_' + $(this).attr('data-address-id')).toggle();
		return false;
	});





	/*
	//
	//
	// INSTAGRAM LIVE FEED
	//
	//
	//////////////////////////////////////////////////////////////////////////////////// */
	if ($('.instagram-live-feed').length > 0)
	{
		loadInstagramLiveFeed();
	}

	function loadInstagramLiveFeed()
	{
		$.ajax(
		{
	    type: 'GET',
	    url: 'https://dev-shopify.vendorshippingrules.com/utilities/tmi.php?callback=the_cb',
	    dataType: 'jsonp',

	  }).done(function(response)
	  {
		  //console.log(response);

			var $owl_carousel = $("<div class='owl-carousel'></div>");

			$.each(response.items, function(i, item)
			{
				var src = item.images.standard_resolution.url;
			  var link = item.link;
			  var $img = $('<div class="instagram-feed-item"><a href="' + link + '" target="_blank"><img src="' + src + '" /></a></div>');
				$img.appendTo($owl_carousel);
			});

			$('.instagram-live-feed').append($owl_carousel);

			$('.instagram-live-feed .owl-carousel').owlCarousel(
			{
				items: 4,
				navigation: true,
				navigationText: ["<svg width='26' viewBox='0 0 27.167 48.167' style='stroke:#000000;'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>", "<svg width='26' viewBox='0 0 27.167 48.167' style='stroke:#000000;'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"],
				pagination:true,
				itemsCustom: [[0, 2], [450, 3], [768, 4], [1125, 5]]
			});

	  }).fail(function(error)
	  {
		 	//console.log(error);
			$('.section-instagram').hide();
		});

	  return;
	}





	/*
	//
	//
	// FOR FREE ITEM BUNDLES...
	// => ALSO REMOVE FREE ITEM FROM CART WHEN REMOVING PARENT ITEM.
	//
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$(document).on('click', '.cart-item .item-remove',(function(e)
	{
		if ($(this).attr('data-bundle-free-item') == 'true')
		{
			e.preventDefault();

			console.log('removing bundled item');

			var bundle_key = $(this).attr('data-bundle-key');

			var updates = {};

			$('.cart-item[data-bundle-key="' + bundle_key + '"]').each(function(i,v)
			{
				var variant_id = $(this).attr('data-variant-id');
				updates[variant_id] = 0;

			});

			queue(function()
			{
				return $.post('/cart/update.js', { updates: updates },
				function() { }, 'json').done(function(variant) { }).fail(function(msg) { });
			});

			queue(function()
			{
				window.location.reload();
			});

			return false;
		}

		// var cart_total = $('.cart-subtotal').attr('data-total');
		// var item_price = $(this).attr('data-item-price');
		// var remove_link = $(this).attr('href');
		// if (cart_total - item_price <= 0 )
		// {
		// 	e.preventDefault();
		// 	queue(function()
		// 	{
		// 		console.log("cart empty, clearing freebies...");
		// 		clearFreebies(remove_link);
		// 	});
		// }
	}));




	/*
	function getParameterByName(name, url) {
	if (!url) {
	  url = window.location.href;
	}
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	    results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	*/


	/*
	//
	//
	// AUTOMATICALLY ADD (OR REMOVE) FREE ITEM TO CART
	// TRIGGERED BY script TAG ON cart.liquid
	//
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	if (typeof(ADD_FREE_ITEM_TO_CART) != 'undefined')
	{
		return $.post('/cart/add.js',
		{
			quantity: 1,
			id: ADD_FREE_ITEM_TO_CART,
			properties: {
				'Freebie': 'True'
			}

		}, function()
		{
			console.log('free bonus added');

		}, 'json').done(function(variant)
		{
			// console.log(variant);
			// window.location.reload()
			$("#main-content").load("/cart #main-content");

		}).fail(function(msg)
		{
			// console.log(msg);

		});

	}

	if (typeof(ADD_FREE_ITEMS_TO_CART) != 'undefined')
	{

			var cartUpdates = [];

			var testy = jQuery.getJSON( "/cart.js", function() {
					for (i = 0; i < testy.responseJSON.items.length; i++) {
						if (testy.responseJSON.items[i].properties["Freebie"]) {
							cartUpdates.push(0)
						} else {
							cartUpdates.push(testy.responseJSON.items[i].quantity)
						}
					}
				}).done( function () {
					// console.log('DONE...cartUpdates: ' + cartUpdates);
					var params = {
		          type: 'POST',
		          url: '/cart/update.js',
		          data: { updates: cartUpdates },
		          dataType: 'json',
							async: true,
		          success: function() {
								// console.log("params cart updates: " + cartUpdates);
								// console.log("FREEBIES CLEARED VIA ASYNC");
								// console.log("FREE ITEMS ARRAY: " + ADD_FREE_ITEMS_TO_CART);
								for (i = 0; i < ADD_FREE_ITEMS_TO_CART.length; i++) {
									(function(i) {
										var variant_id = ADD_FREE_ITEMS_TO_CART[i];
										queue(function() {
											return $.post('/cart/add.js',
											{
												quantity: 1,
												id: variant_id,
												properties: {
													'Freebie': 'True'
												}

											}, function()
											{
												// console.log('free bonus added');

											}, 'json').done(function(variant)
											{
												// console.log(variant);


											}).fail(function(msg)
											{
												console.log(msg);

											});
										});
									})(i)
								};
								queue(function()
								{
									// console.log ("BULK ADD QUEUE COMPLETE!");
									// window.location.reload()
									$("#main-content").load("/cart #main-content");
								});
		          },
		          error: function(msg) {
		            // console.log(msg);
		          }
		        };
					// console.log(params);
					$.ajax(params);
					});
	}

	if (typeof(REMOVE_FREE_ITEMS_FROM_CART) != 'undefined')
	{
		var cartUpdates = [];
		var testy = jQuery.getJSON( "/cart.js", function() {
			for (i = 0; i < testy.responseJSON.items.length; i++) {
				if (testy.responseJSON.items[i].properties["Freebie"] && REMOVE_FREE_ITEMS_FROM_CART.includes(testy.responseJSON.items[i].variant_id) ) {
				// if (testy.responseJSON.items[i].properties["Freebie"] && testy.responseJSON.items[i].variant_id == REMOVE_FREE_ITEM_FROM_CART) {
					cartUpdates.push(0)
				} else {
					cartUpdates.push(testy.responseJSON.items[i].quantity)}
				}
			// console.log( "success, cart updates are: " + cartUpdates );
			jQuery.post('/cart/update.js', {updates: cartUpdates}, function() {
				// window.location.reload()
				$("#main-content").load("/cart #main-content");
				// window.location.reload();
			});
		}).done()
	}


	if (typeof(REMOVE_ALL_FREEBIES_FROM_CART) != 'undefined')
	{
		var cartUpdates = [];
		var testy = jQuery.getJSON( "/cart.js", function() {
			for (i = 0; i < testy.responseJSON.items.length; i++) {
				if (testy.responseJSON.items[i].properties["Freebie"] && testy.responseJSON.items[i].variant_id != REMOVE_ALL_FREEBIES_FROM_CART) {
					cartUpdates.push(0)
				} else {
					cartUpdates.push(testy.responseJSON.items[i].quantity)}
				}
			// console.log( "success, cart updates are: " + cartUpdates );
			jQuery.post('/cart/update.js', {updates: cartUpdates}, function() {
				// console.log("freebies removed, reloading...");
				// window.location.reload()
				$("#main-content").load("/cart #main-content");
			});
		}).done()
	}

	function clearFreebies(redirect) {
		var cartUpdates = [];
		var testy = jQuery.getJSON( "/cart.js", function() {
			for (i = 0; i < testy.responseJSON.items.length; i++) {
				if (testy.responseJSON.items[i].properties["Freebie"]) {
					cartUpdates.push(0)
				} else {
					cartUpdates.push(testy.responseJSON.items[i].quantity)}
				}
			jQuery.post('/cart/update.js', {updates: cartUpdates}, function() {
				window.location = redirect;
			});
		});
	}

  	/*
	//
	//
	// WHOLESALE INQUIRY FORM VALIDATION
	//
	//
	//////////////////////////////////////////////////////////////////////////////////// */
  	$('#btn-submit-wholesale-inquiry').click(function(e)
	{
      var has_errors = false;
      var has_email_error = false;

      var $form = $(this).parents('form');

      $form.find('.error-message').remove();

      $form.find('input').each(function(i,v)
	  {
        $(this).removeClass('error');

        if ($(this).prop('required') && $(this).val() == '')
        {
          $(this).addClass('error');
          has_errors = true;
        }

        if ($(this).attr('name') == 'contact[email]')
        {
          if (!isEmail($(this).val()))
          {
            $(this).addClass('error');
            has_email_error = true;
          }
        }
      });

	  if (has_errors && has_email_error)
      {
        $("<p class='error-message'>Please enter a valid email address and complete all required fields.</p>").insertBefore($(this));
        return false;
      }

      if (has_email_error)
      {
        $("<p class='error-message'>Please enter a valid email address.</p>").insertBefore($(this));
        return false;
      }

      if (has_errors)
      {
      	$("<p class='error-message'>Please complete all required fields.</p>").insertBefore($(this));
        return false;
      }

      return true;

    });

    function isEmail(email)
  	{
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    }


  	$('#wholesale-register-form input').on('focus',function(e)
	{
      $(this).removeClass('error');
    });



	/*
	//
	//
	// FLOATING INPUT LABELS
	//
	//
	//////////////////////////////////////////////////////////////////////////////////// */
    $('.input-container-floating-label input, .input-container-floating-label textarea').on('keyup', function()
    {
      if ($(this).val() == '')
      {
        $(this).parents('.input-container-floating-label').removeClass('complete');
      }
      else
      {
        $(this).parents('.input-container-floating-label').addClass('complete');
      }
    });

    $('.input-container-floating-label input, .input-container-floating-label textarea').on('blur', function()
    {
      if ($(this).val() == '')
      {
        $(this).parents('.input-container-floating-label').removeClass('complete');
      }
    });

  
  	/*
	//
	//
	// PRODUCT BLOCK ADD TO CART
	//
	//
	//////////////////////////////////////////////////////////////////////////////////// */
	$('.block-add-to-cart').on('click', function() {
      if ($(this).hasClass('added')) {
          return false;
      }
      var productId = $(this).data('product-id');
      console.log('add ' + productId + ' to cart!');
      CartJS.addItem(productId, 1);
      $(this).addClass('added');
    });
  	$(document).on('cart.requestComplete', function(event, cart) {
      updateCartTotals();
      $('.added').animate({'opacity': 0}, 250, function () {
        $(this).text('Added :)');
          $(this).css('background-color', 'pink');
      }).animate({'opacity': 1}, 500);
      //$('.added').text('Added!');
      setTimeout(function() {
 		$('.added').animate({'opacity': 0}, 250, function () {
          $(this).text('Add To Bag');
          $(this).css('background-color', '#fff');
          $(this).removeClass('added');
     	 }).animate({'opacity': 1}, 500);
	  }, 1500);
	});
      $(document).on('cart.ready', function(event, cart) {
        console.log('cartjs ready');
    });

});


$(window).on('load', function(){
  // executes when complete page is fully loaded, including all frames, objects and images
  console.log('window.loaded');
  //window.dispatchEvent(new Event('resize'));
  var resizeEvent = window.document.createEvent('UIEvents'); 
  resizeEvent .initUIEvent('resize', true, false, window, 0); 
  window.dispatchEvent(resizeEvent);
});
